import React from 'react';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';

// Hard stop. No retry CTA.
const Under16Rejection = () => (
  <EmptyState
    headline={COPY.REJECT_UNDER_16_HEADLINE}
    subtitle={COPY.REJECT_UNDER_16_SUBTITLE}
  />
);

export default Under16Rejection;
